export default "__VITE_ASSET__D_IMJa6f__"